import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaTags } from "react-icons/fa";
import Loader from "../../components/Loader/Loader";
import { enqueueSnackbar } from "notistack";
import CardHeader from "../../components/Card/CardHeader";
import ListCard from "../../components/Card/ListCard";
import { deleteStakeholderRequestType, getStakeholderRequestTypes } from "../../services/StakeholderRequestTypeService";

function StakeholderRequestTypeList() {
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  const [requestTypes, setRequestTypes] = React.useState([]);
  const [loader, setLoader] = React.useState(false);

  useEffect(() => {
    fetchStakeholderRequestTypes();
  }, []);

  const fetchStakeholderRequestTypes = async () => {
    try {
      setLoader(true);
      const response = await getStakeholderRequestTypes();
      if (response.success) {
        // Assuming the response contains the data in response.data
        setRequestTypes(response.data);
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch stakeholder request types", { variant: "error" });
      return [];
    } finally {
      setLoader(false);
    }
  };

  const deleteHandler = async (id) => {
    try {
      setLoader(true);
      const response = await deleteStakeholderRequestType(id);
      if (response.status === 200) {
        enqueueSnackbar("Stakeholder Request Type deleted successfully", { variant: "success" });
        // Instead of calling componentDidMount, you can update Redux state here
        fetchStakeholderRequestTypes();
      }
    } catch (error) {
      // Handle error
      return error;
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="card">
      {loader ? (<Loader />) :
        (<div className="subject-list">
          <div className="animated">
            <CardHeader
              title="Request Types"
              icon={<FaTags />}
              permissions={permissions}
              button={permissions.includes("stakeholder.request.type.create") && (
                <Link className="btn btn-primary" to="/stakeholder-request-type/create">Add</Link>
              )}
            />
            <div className="card-body row">
              {requestTypes && requestTypes.map((item, idx) => (
                <ListCard
                  key={idx}
                  colSize="col-md-6"
                  permissions={permissions}
                  updatePermission="stakeholder.request.type.update"
                  deletePermission="stakeholder.request.type.delete"
                  updateUrl={`/stakeholder-request-type/update/${item.id}`}
                  icon="fa-solid fa-book-open"
                  item={item}
                  onDelete={deleteHandler}
                  description={
                    <div className="st-en-d">
                      <div className="small">
                        <span>Request SubTypes:</span>
                        <span>
                          {item.sub_types && item.sub_types.map((subType, index) => (
                            <React.Fragment key={index}>
                              {index === 0 ? (
                                <React.Fragment>
                                  {subType.name}
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  , {subType.name}
                                </React.Fragment>
                              )}{" "}
                            </React.Fragment>
                          ))}
                        </span>
                      </div>
                    </div>
                  }
                />
              ))}
            </div>
            <div className="card-body evaluating-table">
              {/*subjectData.length ? (
                <Pagination
                  totalPage={lastPage}
                  handlePageChange={(i) => fetchSubjects(i)}
                />
              ) : null*/}
            </div>
          </div>
        </div>
        )}
    </div>
  );
}
export default StakeholderRequestTypeList;
